skrilla.directive('container',function() {
    return {
        templateUrl: 'directives/container/container.html',
        controller: function ($scope, $timeout, $mdSidenav, adminService, $window, $document, objectChangeService, envService, loginService, cacheService, modalService, srefService, dateService, adminV2Service) {
            if($window.localStorage.lockedSideNav == "true"){
                $scope.locked = true;
            }else{
                $scope.locked = false;
            }
            function updateLocalStorage(){
                $window.localStorage.lockedSideNav = $scope.locked.value;
            }

            if (envService.get() !== 'production') {
                let favicons = document.querySelectorAll('head link.favicon')
                favicons.forEach(it => {
                    it.href = it.href.replace("/images/", "/images/staging/")
                })
            }


            $scope.timezones = dateService.getTimeZones()
            $scope.timezoneId = $window.localStorage.timezone || "LOCAL"
            $scope.timezone = $scope.timezones[$scope.timezoneId];
            cacheService.registerObject("timezone", $scope.timezone)

            $scope.updateTZ = function(){
                $window.localStorage.timezone = $scope.timezoneId;
                $scope.timezone = $scope.timezones[$scope.timezoneId];
                cacheService.registerObject("timezone", $scope.timezone)
                modalService.confirm("Do you want to refresh the page to view data in the " + $scope.timezone.name + " timezone", function () {
                    $window.location.reload();
                });
            }

            $scope.getClass = function(){
                return envService.get() === "production" ? 'md-theme-indigo' : 'md-accent' ;
            }
            $scope.getEnvironmentTitle = function(){
                return envService.get() === "production" ? 'Picklebet Admin' :  'Picklebet Admin - ' + envService.get().toUpperCase()  ;
            }

            $scope.logout = function(){
                loginService.logout();
            }
            $scope.login = function(){
                srefService.go("login");
            }

            $scope.isLoggedIn = adminService.isLoggedIn;

            objectChangeService.registerObject("container", "locked", $scope);
            objectChangeService.listenForChange("container", updateLocalStorage);

            $scope.opened = false;

            $scope.hasRole = adminService.hasRole;


            $scope.pages = [
                getPage("Users", "users", "adminViewUser"),
                getPage("Accounts", "accounts", "adminViewAccounts"),
                getPage("Bets", "bets", "adminViewBet"),
                getPage("Bet Ticker", "betTicker", "adminViewBet"),
                getPage("Betting Markets", "bettingMarkets", "adminViewBettingMarkets"),
                getPage("Pickems Contests", "pickemsContests", "adminViewContest"),
                getPage("Data", "data", "adminViewData"),
                getPage("Manual Transactions", "manualTransactions", "adminViewManualTransaction"),
                getPage("Withdrawals", "withdrawals", "adminViewWithdrawal"),
                getPage("Deposits", "deposits", "adminViewAccounts"),
                getPage("Limits", "limits", "adminViewLimit"),
                getPage("Promotions", "promotions", "adminViewPromotion"),
                getPage("Financials", "financials", "adminViewFinancials"),
                getPage("NTRC", "ntrc", "adminViewFinancials"),
                getPage("Reports", "reports", "adminViewFinancials"),
                getPage("Skrilla Jobs", "skrillaJobs", "adminViewSkrillaJobs"),
                getPage("Excluded Users Register", "excludedUsers", "adminViewUser"),
                getPage("Admins", "admins", "adminViewAdmin"),
                getPage("API Configurations", "permissions", "adminViewUser"),
            ];


            function getPage(name, location, show){
                return {name: name, location: location, show:show};
            }

            $scope.toggleLeft = function(lock){
                $scope.opened = !$scope.opened;
                if($scope.locked == true){
                    $scope.locked = false;
                }else{
                    $mdSidenav("left").toggle();
                }
            }

            $scope.closeIfNotLocked = function () {
                if($scope.locked == false) $mdSidenav("left").toggle();
            }

            $scope.openAdminV2 = function () {
                adminV2Service.openV2();
            }

        }
    };
});
